import { toRem, toRems } from "../../../../helpers/theme";

const style = ({ theme }) => {
    const variant = "primary"; // @TODO: expose to prop if needed
    const config = {
        padding: 6,
        fontSize: 12,
        border: {
            radius: 4,
        },
        icon: {
            size: 50,
            offset: {
                top: -14,
                bottom: -6,
            },
        },
    };
    return {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        margin: 0,
        padding: toRem(config?.padding),
        borderRadius: toRem(config?.border?.radius),
        backgroundColor: theme.colors.button[variant]?.background?.default,
        color: theme.colors.button[variant]?.text?.default,
        fontFamily: theme.typography?.font.default,
        fontWeight: theme.typography?.fontWeight.bold,
        fontSize: toRem(config?.fontSize),
        lineHeight: 1,
        textAlign: "center",
        border: "none",
        outline: 0,
        overflow: "hidden",
        cursor: "pointer",
        "& .btnIcon": {
            display: "block",
            fontSize: toRem(config?.icon?.size),
            margin: toRems([config?.icon?.offset?.top, 0, config?.icon?.offset?.bottom]),
            svg: {
                path: {
                    fill: "currentColor",
                },
            },
        },
    };
};

export default style;
